// extracted by mini-css-extract-plugin
export default {"formText":"styles_formText__neUym","textareaWrap":"styles_textareaWrap__58Iey","charCounter":"styles_charCounter__4D-9u"};